import { WidgetTrustpilotProps } from './types';
import { useEffect, useRef } from 'react';
import useI18n from '@hooks/i18n/useI18n';
import { useScript } from '@monofront/business/hooks';

const BUSINESS_UNIT_ID = {
  fr: '5b0ebb6897ae1c0001e39a75',
  de: '63174e03a4dd63cdb25ef800',
};

declare global {
  interface Window {
    Trustpilot: any;
  }
}

const WidgetTrustpilot: React.FC<WidgetTrustpilotProps> = ({
  templateId,
  height,
  width,
  theme,
  stars = '4,5',
}) => {
  const { locale, iso } = useI18n();
  const divRef = useRef<HTMLDivElement>(null);

  const loaded = useScript(
    'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
  );

  useEffect(() => {
    if (
      typeof window != 'undefined' &&
      typeof window['Trustpilot'] != 'undefined'
    ) {
      window.Trustpilot.loadFromElement(divRef.current);
    }
  }, [loaded]);

  return (
    <div
      ref={divRef}
      className="trustpilot-widget tw-h-full"
      data-locale={iso.replace('_', '-')}
      data-review-languages={locale}
      data-template-id={templateId}
      data-businessunit-id={BUSINESS_UNIT_ID[locale]}
      data-style-height={height}
      data-style-width={width}
      data-theme={theme}
      data-stars={stars}
    ></div>
  );
};

export default WidgetTrustpilot;
